import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import UIcon, { IconKey } from "lib/icons/untitled_ui/UIcon";

type StageType = {
  label: string;
  color: string;
  iconColor: string;
  iconName: string;
  truncate?: boolean;
};

export function Stage({ label, iconName, color, iconColor, truncate = false }: StageType) {
  const icon = iconName as IconKey;

  return (
    <StageSelectTagContainer backgroundColor={color} truncate={truncate}>
      {iconName && <UIcon icon={icon} color={iconColor} size={16} />}
      <LabelText title={label}>{label}</LabelText>
    </StageSelectTagContainer>
  );
}

const StageSelectTagContainer = styled(Flex)<{ backgroundColor: string; truncate: boolean }>(
  ({ backgroundColor, truncate, theme }) => ({
    display: "flex",
    alignItems: "center",
    color: theme.colors.sysTextDefault,
    gap: 8,
    width: "fit-content",
    minHeight: 26,
    padding: "2px 8px",
    backgroundColor,
    borderRadius: 2,
    // When rendered in a width-constrained container (e.g. a table cell), opt in to shrinking
    // so LabelText's ellipsis activates instead of the pill overflowing.
    ...(truncate && { maxWidth: "100%", minWidth: 0, overflow: "hidden" }),
  }),
);

const LabelText = styled.span({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0, // Allow flex child to shrink below content size
});
